module.exports = __webpack_public_path__ + "static/img/welcome.3e496c3a.jpg";